import { PackageMiscellaneousFormController } from '../controller/PackageMiscellaneousFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { DeepPartial } from 'typeorm';
import { PackageData } from '../../../types/package-data';
import { Observable } from 'rxjs';
import { MonthlyProductType } from '../../../../license/types/MonthlyProductType';

export class PackageMiscellaneousFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageMiscellaneousFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageMiscellaneousFormController,
    });
  }

  public showSubmitQuarantineSectionByOperationMode(operationMode: MonthlyProductType) {
    this.controller.showSubmitQuarantineSectionByOperationMode(operationMode);
  }

  public get value(): DeepPartial<PackageData> {
    const formValues: object = this.controller.view.formGroup.value;
    if (this.controller.view.dom.$submitQuarantineSection.classList.contains('hidden')) {
      formValues['settings']['miscSettings']['submitQuarantine'] = false;
    }
    return formValues;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public setPackageData(packageData): void {
    this.controller.view.setPackageData(packageData);
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  public resetToDefaultValues(): void {
    this.controller.resetToDefaultValues();
  }
}
